const reliability = {
  create: "RELIABILITY REPORT",
  profile: "RELIABILITY REPORT DETAILS",
  search: "Search",
  equipmentTag: "Asset Tag",
  equipmentType: "Asset Type",
  company: "Company",
  repairDate: "Reliability Inspection Date",
  createdBy: "Created By",
  customer: "Customer",
  Reliabilty: "Reliability",
  submit: "SUBMIT",
  list: "Reliability Reports",
  delete: "DELETE",
  lblselectdate: "Select report date and time",
  lblmechanical: "Mechanical Condition",
  trafficlights: {
    smooth: "Running: Smooth",
    warning: "Running: Warning",
    alarm: "Running: Alarm"
  },
  conditions: {
    smooth: "Smooth",
    warning: "Warning",
    alarm: "Alarm"
  },
  datepicker: {
    title: "Choose a date range",
    okbtn: "DONE",
    cancelbtn: "CANCEL"
  },
  statuslights: {
    running: "Running",
    standby: "Standby",
    maintenance: "Maintenance",
    failure: "Failure"
  },
  isThisAFailure: " Is this a failure? ",
  hint1: "More Details",
  hint2: "Result from reliability analysis",
  status: "Status",
  backbtn: "Go Back"
};
export default reliability;
